<template>
  <v-row v-show="showSelect == 'Documents'">
    <v-col cols="12" class="text-center">
      <h2>Main Document</h2>
    </v-col>
    <v-col cols="10" style="margin-left: 8.3333333333%">
      <v-simple-table fixed-header v-if="addedDocuments.length > 0">
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left">Tracer No.</th>
              <th class="text-left">Sender</th>
              <th class="text-left">Subject</th>
              <th class="text-left">Main Document</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="document in addedDocuments" :key="document.index">
              
              <td style="width: 31.1%" v-if="document.file_type == `image`"><a style="text-decoration: none" @click="previewImage(`${fileSystemUrl}/view/${document.filepath_url}`)"> {{ document.transaction_id }}</a></td>
              <td style="width: 31.1%" v-else><a style="text-decoration: none" :href="`${fileSystemUrl}/view/${document.filepath_url}`" target="_blank"> {{ document.transaction_id }}</a></td>
              <td style="width: 30.5%">{{ document.sender }}</td>
              <td style="width: 15.7%">{{ document.subject }}</td>
              <td>
                <v-switch
                  v-model="document.isMainDocument"
                  @click="toggleMainDocument(document.index, document.isMainDocument)"
                ></v-switch>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-col>
    <v-col cols="12" class="text-center" v-if="getSupportingDocuments.length > 0">
      <h2>Supporting Documents</h2>
    </v-col>
    <v-col cols="10" class="text-right" style="margin-left: 8.3333333333%" v-if="getSupportingDocuments.length > 0">
      <!-- <span style="font-size: 20px"><b>Supporting Document/s</b></span> -->
      <!-- <v-btn color="primary" depressed @click="dialog = true">Add Documents</v-btn> -->
      <v-btn color="primary" depressed class="ml-2" :disabled="ableToDelete" @click="deleteFiles">Delete</v-btn>
    </v-col>
    <v-col cols="10" style="margin-left: 8.3333333333%" v-if="getSupportingDocuments.length > 0">
        <div >
        <v-simple-table
          fixed-header
          :height="tableHeight"
          class="files-table"
        >
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">File name</th>
                <th class="text-left">Sender</th>
                <th class="text-left">Subject</th>
                <th class="text-left">Main Document</th>
                <th>
                  Action
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in updated_data" :key="item.index">
                <td style="width: 31.1%" v-if="item.document.file_type == `image`"><a style="text-decoration: none" @click="previewImage(`${fileSystemUrl}/view/${item.document.filepath_url}`)"> {{ shortText(item.document.filepath_url) }}</a></td>
                <td style="width: 31.1%" v-else><a style="text-decoration: none" :href="`${fileSystemUrl}/view/${item.document.filepath_url}`" target="_blank"> {{ shortText(item.document.filepath_url) }}</a></td>
                <td style="width: 30.5%">{{sender}}</td>
                <td style="width: 15.7%">{{subject}}</td>
                <td>
                  <v-switch
                    v-model="item.isMainDocument"
                    @click="updateMainDocument(index)"
                  ></v-switch>
                </td>
                <td>
                  <v-checkbox
                    @click="selectFile(item.document.id)"
                    v-model="item.toggle"
                  ></v-checkbox>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
        <v-card-subtitle>Total: {{updated_data.length}} file/s</v-card-subtitle>
      </div>
    </v-col>
    <v-col cols="12" class="text-center mt-n15 mb-n2">
      <v-btn class="mx-2" fab dark color="indigo" @click="dialog = true">
        <v-icon>mdi-plus</v-icon>
      </v-btn>
      <AddSupportingDocument
        :dialog="dialog"
        :document_id="document_id"
        @closeDialog="closeDialog"
      />
    <ImageViewer :dialog="viewImage" :url="object_url" @closeDialog="closeImageView"/>
    </v-col>
    
    <loading-overlay v-if="loading"/>
  </v-row>
</template>

<script>
  import { fileSystemUrl } from '../config/config.json'
  import { mapActions, mapGetters } from "vuex";
  import AddSupportingDocument from "./routes/modal/AddSupportingDocument.vue";
  import Swal from "sweetalert2";
  import ImageViewer from "./documents/modal/ImageViewer.vue"
  import LoadingOverlay from "./common/LoadingOverlay.vue";
  export default {
    name: "AssignDocuments",
    props: {
      showSelect: String,
    },
    components: {
      AddSupportingDocument,
      LoadingOverlay,
      ImageViewer
    },
    data() {
      return {
        dialog: false,
        viewImage: false,
        object_url: null,
        supporting_documents: [],
        sender: null,
        subject: null,
        document_id: null,
        selected_documents: [],
        ableToDelete: true,
        loading: false,
        updated_data: [],
        shouldUpdate: true,
        fileSystemUrl: fileSystemUrl,
      };
    },
    methods: {
      ...mapActions(["toggleMainRouteDocument", "attachSupportingDocuments", "clearSupportingDocuments", "deleteSupportingDocuments"]),
      updateMainDocument(index){
          this.shouldUpdate = false
          this.addedDocuments.forEach((document, t) => {
            if(document.isMainDocument){
              this.toggleMainDocument(t, false)
            }
          })
          this.updated_data.forEach((item, idx) => {
              if(idx !== index)
                  item.isMainDocument = false
          })
          let temp = this.updated_data
          this.updated_data = []
          this.updated_data = temp
          
          this.attachSupportingDocuments({documents: this.updated_data, isUpdate: true})
          this.mainDocumentSelected()
      },
      previewImage(url) {
        this.object_url = url
        this.viewImage = true
      },
      closeImageView() {
        this.viewImage = false
        this.object_url = null
      },
      mainDocumentSelected() {
        let body = {
          main: this.addedDocuments,
          sub: this.updated_data
        }
        this.$emit('checkMainDocument', body)
      },
      deleteFiles() {
         Swal.fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, delete it!",
        }).then((result) => {
          if (result.isConfirmed) {
            this.loading = true;
            this.deleteSupportingDocuments(this.selected_documents).then(() => {
                this.selected_documents = []
                this.loading = false
                this.ableToDelete = true
                Swal.fire(
                  "Deleted!",
                  "Your file has been deleted.",
                  "success"
                );
        
            });
          }
        });
      },
      selectFile(id) {
        try {
          this.selected_documents.forEach((item, index) => {
            if(item == id){
              this.selected_documents.splice(index, 1)
              throw 'Yes'
            }
          })
          throw 'No'
        } catch (e) {
          if(e == 'No')
            this.selected_documents.push(id)
        }
        if(this.selected_documents.length > 0)
          this.ableToDelete = false
        else
          this.ableToDelete = true
      },
      closeDialog(val) {
        this.dialog = val;
      },
      toggleMainDocument(index, val) {
        this.shouldUpdate = false
        this.toggleMainRouteDocument({index, val}).then(() => {
          this.shouldUpdate = true
        });
        if(val){
          this.updated_data.forEach((item) => {
                  item.isMainDocument = false
          })
          let temp = this.updated_data
          this.updated_data = []
          this.updated_data = temp
          this.attachSupportingDocuments({documents: this.updated_data, isUpdate: true})
        }
        this.mainDocumentSelected()
      },
      shortText(name) {
        name = name.substring(21)
        return name.slice(0, 30).concat("...");
      },
      createSupportingDocument() {
        this.supporting_documents = []
        this.clearSupportingDocuments([]).then(() => {
          this.addedDocuments.forEach(doc => {
            this.document_id = doc.id
            this.sender = doc.sender
            this.subject = doc.subject
            doc.supporting_documents.forEach(item => {
              this.supporting_documents.push({document: item, isMainDocument: false})
            })
          })
          this.attachSupportingDocuments({documents: this.supporting_documents, isUpdate: false})
        })
      }
    },
    created() {
      this.createSupportingDocument()
    },
    computed: {
      ...mapGetters(["addedDocuments", "getSupportingDocuments"]),  
      tableHeight() {
        if (this.updated_data.length == 1) return "130px";
        else if (this.updated_data.length == 2) return "200px";
        else return "240px";
      },
    },
    watch: {
      addedDocuments() {
        if(this.shouldUpdate)
        this.createSupportingDocument()
      },
      getSupportingDocuments() {
        this.updated_data = []
        if(this.getSupportingDocuments.length > 0)
        this.getSupportingDocuments.forEach(item => {
          this.updated_data.push({document: item.document, isMainDocument: item.isMainDocument, toggle: false})
        })
      },
    }
  };
</script>

<style scoped>
.files-table {
  table-layout: fixed;
}
</style>
